<template>
  <div
    class="footer-button"
    :class="isSticky ? 'footer-button_sticky' : 'footer-button_sticky_no'"
  >
    <el-button
      v-if="isShowCancelRequest"
      @click="$emit('cancelRequest')"
      style="margin-left: 0;"
    >
      Cancel Request
    </el-button>
    <template v-if="isEdit">
      <el-button :loading="loading" @click="$emit('cancel')">Cancel</el-button>
      <el-button
        :loading="loading"
        @click="$emit('submit')"
        type="primary"
        style="margin-left: 0;"
        >Save
      </el-button>
    </template>
    <template v-else-if="isApprove">
      <el-button :loading="loading" @click="$emit('reject')">Reject</el-button>
      <el-button
        :loading="loading"
        @click="$emit('approve')"
        type="primary"
        style="margin-left: 0;"
        >Agree
      </el-button>
    </template>
    <template v-else-if="isApply || isRenew || isResubmit">
      <el-button :loading="loading" @click="$emit('cancel')">Cancel</el-button>
      <el-button
        :loading="loading"
        @click="$emit('submit')"
        type="primary"
        style="margin-left: 0;"
        >Submit
      </el-button>
    </template>
    <template v-else-if="isConfirm">
      <el-button
        :loading="loading"
        @click="$emit('agree')"
        type="primary"
        :disabled="confirmDisabled"
        style="margin-left: 0;"
        >Agree
      </el-button>
    </template>
  </div>
</template>

<script>
export default {
  name: "footerButton",
  emits: ["cancel", "submit", "reject", "approve", "agree", "cancelRequest"],
  props: {
    isApprove: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isApply: {
      type: Boolean,
      default: false
    },
    isResubmit: {
      type: Boolean,
      default: false
    },
    isRenew: {
      type: Boolean,
      default: false
    },
    isConfirm: {
      type: Boolean,
      default: false
    },
    confirmDisabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    isShowCancelRequest: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isSticky: true,
      originalPosition: void 0
    };
  },
  methods: {
    handleScroll() {
      this.isSticky = document.getElementsByClassName("footer-button")[0].offsetTop < this.originalPosition;
    },
    init() {
      const footerButtonDom = document.getElementsByClassName("footer-button")[0];
      this.originalPosition = footerButtonDom.offsetTop + 30; // 保存原始位置
      // 开始粘性定位
      footerButtonDom.style.position = "sticky";
      footerButtonDom.style.bottom = 0;
      this.isSticky = true;
      document
        .getElementsByClassName("mainpage")[0]
        .addEventListener("scroll", this.handleScroll);
    },
    clear() {
      this.originalPosition = 0;
      document
        .getElementsByClassName("mainpage")[0]
        .removeEventListener("scroll", this.handleScroll);
    }
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    this.clear()
  }
};
</script>

<style scoped>
.footer-button {
  width: 100%;
  padding: 20px;
  background: #fff;

  justify-content: center;
  align-items: center;
  gap: 18px;
  transition: all 0.3s;
  z-index: 997;
  display: flex;
}

.footer-button.footer-button_sticky {
  box-shadow: 0 -5px 13px 0 rgba(52, 3, 15, 0.05);
}

.footer-button.footer-button_sticky_no {
  box-shadow: none;
}

.footer-button /deep/ .el-button {
  min-width: 120px;
  height: 42px;
  font-size: 16px;
}

/deep/ .el-tooltip__popper {
  border: none !important;
  width: auto;
  font-size: 16px;
  color: #505050;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.08) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/smbSales/components/footerButton.vue